import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function validatePrimaryIRISDocumentId(regex: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') {
      return null;
    }

    const isNumericOnly = regex.test(control.value);
    return isNumericOnly ? null : {numericError: {value: true}}
  }
}
